<template>
  <div>
    <SmartRow
      class="form flex sub-form justify-between flex-nowrap flex-row p-1"
    >
      <div class="w-full">
        <SmartInput
          label="Matrícula do Vendedor"
          placeholder="Informe o número da matricula"
          id="matricula"
          name="matricula"
          disabled
          v-model="value.matricula"
          v-validate="'required'"
          :error="errors.first('matricula')"
          :mask="['###.###.###-##', '#'.repeat(11)]"
        />
      </div>
      <div class="w-full">
        <SmartInput
          label="Nome do vendedor"
          placeholder="Informe o nome do vendedor"
          id="sellerName"
          name="sellerName"
          v-model="value.sellerName"
          v-validate="'required'"
          :mask="'N'.repeat(100)"
          :error="errors.first('sellerName')"
        />
      </div>
    </SmartRow>
    <SmartRow
      class="form flex sub-form justify-between flex-nowrap flex-row p-1"
    >
      <div class="w-full">
        <div class="smart-label text-left ml-1 mb-1-2">Canal de Venda</div>
        <div class="flex flex-row mt-1 ml-1">
          <v-radio-group
            class="m-0"
            v-model="value.canalVenda"
            :mandatory="false"
            row
          >
            <v-radio
              label="Loja Própria TIM"
              @change="aoAlterarCanal('TIM STORE PROPRIA')"
              value="TIM STORE PROPRIA"
            />
            <v-radio
              label="Revenda"
              @change="aoAlterarCanal('REVENDAS')"
              value="REVENDAS"
            />
          </v-radio-group>
        </div>
      </div>
      <div class="w-full">
        <SmartSelect
          id="storeName"
          label="Nome da Loja"
          itemText="descricao"
          itemValue="id"
          :items="placesFiltered"
          v-model="value.storeId"
          noDataText="LOJA NÃO CADASTRADA"
          :autocomplete="true"
          name="storeName"
          @change="aoAlterarLoja"
          v-validate="'required'"
          :error="errors.first('storeName')"
          placeholder="Informe o Nome da Loja"
        />
        <!-- @change="loadPlanInfo"-->
      </div>
    </SmartRow>
    <SmartRow
      class="form flex sub-form justify-between flex-nowrap flex-row p-1"
      v-if="
        (term.tipoVenda === 'posVenda' && term.posVenda.isTrocaAparelho) ||
        (term.tipoVenda === 'posVenda' && term.posVenda.isTransferencia)
      "
    >
      <div class="w-full">
        <div class="smart-label text-left ml-1 mb-1-2">
          Incluir Planos Antigos ?
        </div>
        <div class="flex flex-row mt-1 ml-1">
          <v-radio-group
            class="m-0"
            v-model="withOldPlans"
            :mandatory="false"
            row
          >
            <v-radio label="Sim" :value="true" @change="popularPlanos(true)" />
            <v-radio
              label="Não"
              :value="false"
              @change="popularPlanos(false)"
            />
          </v-radio-group>
        </div>
      </div>
    </SmartRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "StoreInformationElement",
  data() {
    return {
      withOldPlans: false,
      payment: {},
      placesFiltered: [],
    };
  },
  props: {
    value: {}, // eslint-disable-line
  },
  computed: {
    ...mapGetters({
      term: "term/term",
    }),
  },
  mounted() {
    this.payment = JSON.parse(JSON.stringify(this.term.payment));
    this.aoAlterarCanal(this.term.payment.canalVenda);
  },
  methods: {
    ...mapActions({
      getStoreInfo: "term/getStoreInfo",
      getPlansInfo: "term/getPlansInfo",
      setPayment: "term/setPayment",
    }),
    async isValid() {
      await this.$validator.validateAll();
      return Object.keys(this.fields).every((field) =>
        this.focusOnError(field)
      );
    },
    focusOnError(field) {
      const isValid = this.fields[field].valid;
      if (!isValid) {
        document.getElementsByName(field)[0].focus();
      }
      return isValid;
    },
    aoAlterarLoja(selecionado) {
      if (
        selecionado !== null &&
        selecionado !== undefined &&
        selecionado > 0
      ) {
        this.payment.city = "";
        this.payment.state = "";
        this.payment.storeId = selecionado;
        Object.keys(this.placesFiltered).forEach((key) => {
          const val = this.placesFiltered[key];
          if (val.id === selecionado) {
            this.payment.storeDDD = val.ddd;
            this.payment.storeName = val.descricao;
            this.payment.city = val.city;
            this.payment.state = val.state;
            this.payment.local = [val.city, val.state].join("/");

            localStorage.setItem("paymentLocal", this.payment.local);

            var d = new Date();
            this.payment.day = " " + d.getDate();
            this.payment.month =
              " " + d.toLocaleString("pt-BR", { month: "long" });
            this.payment.year = " " + d.getFullYear();
            this.value.storeName = val.descricao;

            this.setPayment(this.payment);
            this.popularPlanos(this.withOldPlans);
          }
        });
      }
    },
    aoAlterarCanal(opcao) {
      this.getStoreInfo({ tipo: opcao, nome: "1" }).then(
        (success) => {
          this.placesFiltered = success.data.data;
          // this.term.lojas = this.placesFiltered;
          this.setPayment(this.payment);
          this.aoAlterarLoja(this.term.payment.storeId);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    popularPlanos(withOldPlansChoice = false) {
      const termo = { ...this.term };
      if (termo.tipoServico === "convergencia") {
        if (
          termo.plan === "liveControleFatura" ||
          termo.plan === "livePosPagoFatura"
        ) {
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "SMP",
            produto: termo.plan,
            ddd: this.payment.storeDDD,
            isDependent: termo.justDependent ? "SIM" : "NAO",
          }).then(
            (success) => {
              this.payment.plans = success.data.data;
              this.$root.$emit("atualizarplanosSMP", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "SCM",
            produto: termo.plan,
            ddd: this.payment.storeDDD,
            isDependent: termo.justDependent ? "SIM" : "NAO",
          }).then(
            (success) => {
              this.payment.plans2 = success.data.data;
              this.$root.$emit("atualizarplanosSCM", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "STFC",
            produto: "fixo",
            ddd: this.payment.storeDDD,
            isDependent: "NAO",
          }).then(
            (success) => {
              this.payment.plans3 = success.data.data;
              this.$root.$emit("atualizarplanosVOIP", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
        } else if (
          termo.plan === "wttxPosPagoFatura" ||
          termo.plan === "wttxControleFatura" ||
          termo.plan === "wttxFixo"
        ) {
          if (termo.plan !== "wttxFixo") {
            this.getPlansInfo({
              canal: this.value.canalVenda,
              tipo: "SMP",
              produto: termo.plan,
              ddd: this.payment.storeDDD,
              isDependent: termo.justDependent ? "SIM" : "NAO",
            }).then(
              (success) => {
                this.payment.plans = success.data.data;
                this.$root.$emit("atualizarplanosSMP", success.data.data);
                this.$forceUpdate();
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            this.getPlansInfo({
              canal: this.value.canalVenda,
              tipo: "STFC",
              produto: "fixo",
              ddd: this.payment.storeDDD,
              isDependent: termo.justDependent ? "SIM" : "NAO",
            }).then(
              (success) => {
                this.payment.plans = success.data.data;
                this.$root.$emit("atualizarplanosSTFC", success.data.data);
                this.$forceUpdate();
              },
              (error) => {
                console.log(error);
              }
            );
          }
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "SMP",
            produto: "wttx",
            ddd: this.payment.storeDDD,
            isDependent: termo.justDependent ? "SIM" : "NAO",
          }).then(
            (success) => {
              this.payment.plans = success.data.data;
              this.$root.$emit("atualizarplanosWTTX", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "SMP",
            produto: termo.plan,
            ddd: this.payment.storeDDD,
            isDependent: termo.justDependent ? "SIM" : "NAO",
          }).then(
            (success) => {
              this.payment.plans = success.data.data;
              this.$root.$emit("atualizarplanosSMP", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "STFC",
            produto: termo.plan,
            ddd: this.payment.storeDDD,
            isDependent: termo.justDependent ? "SIM" : "NAO",
          }).then(
            (success) => {
              this.payment.plans2 = success.data.data;
              this.$root.$emit("atualizarplanosSTFC", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } else {
        this.getPlansInfo({
          canal: this.value.canalVenda,
          tipo:
            (termo.posVenda.isTrocaAparelho ||
              termo.posVenda.isMigrationTransfer ||
              termo.posVenda.isMudancaNumero ||
              termo.posVenda.isMudancaPlano) &&
            termo.tipoVenda === "posVenda"
              ? "posVenda"
              : termo.tipoServico,
          produto:
            (termo.posVenda.isTrocaAparelho ||
              termo.posVenda.isMigrationTransfer ||
              termo.posVenda.isMudancaNumero ||
              termo.posVenda.isMudancaPlano) &&
            termo.tipoVenda === "posVenda"
              ? "posVenda"
              : termo.plan,
          ddd: this.payment.storeDDD,
          isDependent: termo.justDependent ? "SIM" : "NAO",
          withOldPlans: withOldPlansChoice,
        }).then(
          (success) => {
            this.payment.plans = success.data.data;
            this.$root.$emit("atualizarplanos", success.data.data);
            this.$forceUpdate();
          },
          (error) => {
            console.log(error);
          }
        );
        if (termo.tipoServico === "scm") {
          this.getPlansInfo({
            canal: this.value.canalVenda,
            tipo: "STFC",
            produto: "fixo",
            ddd: this.payment.storeDDD,
            isDependent: "NAO",
            withOldPlans: withOldPlansChoice,
          }).then(
            (success) => {
              this.payment.plans2 = success.data.data;
              this.$root.$emit("atualizarplanosVOIP", success.data.data);
              this.$forceUpdate();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .smart-input__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
  .smart-select__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
}
</style>
